export default {"src":"/newStatic/_next/static/media/ascent_icon.b13fa9b7.svg","height":24,"width":24};